<template>
    <div class="apps-wrapper">
        <AppBreadCrumb :paths="[{ title: $t('message.getApps') }]" />
        <div class="apps-main">
            <div class="left">
                <div class="text-area">
                    <div class="title">SUPSIS MOBİL APP</div>
                    <div class="description">
                        <p>IOS ve Android Uygulaması Marketlerde!</p>
                    </div>
                    <div class="buttons">
                        <div class="app-buttons">
                            <a
                                href="https://apps.apple.com/tr/app/supsis-live/id6474663686"
                                target="_blank"
                                class="app-store"
                            >
                                <img src="https://static.supsis.live/common/image/AppStore.png" />
                            </a>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.softcand.supsis&hl=en_ZA&gl=US&pli=1"
                                target="_blank"
                                class="google-play"
                            >
                                <img src="https://static.supsis.live/common/image/GooglePlay.png" />
                            </a>
                        </div>
                        <div class="email-button">
                            <div class="send-mail" @click="showModal = true">Email Gönder</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="gallery">
                    <div class="images">
                        <div class="image little">
                            <img src="https://static.supsis.live/common/doc.supsis.live/output-onlinepngtools.png" />
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                v-if="showModal"
                @cancel="showModal = false"
                :show-footer="false"
                :title="'Uygulama Linki Gönderimi'"
                class="email-modal"
            >
                <div class="mr-auto">
                    <div>
                        <h4 class="font-color">{{ $t("message.weLlSendEmail") }}</h4>
                        <p class="font-color">{{ $t("message.offerlinkSendToMail") }}</p>
                    </div>
                    <div>
                        <md-radio v-model="radio" value="accent" @change="radioControl"
                            >{{ $t("message.theEmail") }}
                        </md-radio>
                        <md-radio v-model="radio" value="Primary" class="md-primary"
                            >{{ $t("message.differentEmail") }}
                        </md-radio>
                    </div>
                    <md-field>
                        <label>{{ $t("message.email") }}</label>
                        <md-input
                            :label="$t('message.email')"
                            autocomplete="off"
                            trim
                            type="tel"
                            v-model="email"
                            @change="isEmailValid()"
                            class="font-color"
                        />
                    </md-field>
                    <md-button
                        @click="send"
                        class="font-color md-dense md-raised md-primary m-0"
                        :disabled="this.validMail === 'classs-error'"
                        >{{ isEmailValid() }}{{ $t("message.send") }}
                    </md-button>
                </div>
            </Modal>
        </div>
    </div>
</template>
<script>
import Modal from "../../components/common/Modal2.vue";
import request from "../../utils/request";
import { mapState } from "vuex";
import AppBreadCrumb from "../../components/common/AppBreadCrumb.vue";

export default {
    name: "apps",
    components: {
        AppBreadCrumb,
        Modal,
    },
    data() {
        return {
            email: "",
            radio: "accent",
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            validMail: "classs-error",
            showModal: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
        radioControl() {
            if (this.radio === "accent") this.email = this.user.email;
            else this.email = "";
        },
    },

    methods: {
        isEmailValid: function () {
            const validationControl = this.email == "" ? "" : this.reg.test(this.email) ? "has-success" : "has-error";
            this.validMail = validationControl === "has-success" ? "classs-succes" : "classs-error";
        },
        async send() {
            if (!!this.email) {
                try {
                    await request.post("/email/supsis-mobile-app-link", {
                        email: this.email,
                    });
                    this.$toasted.show(this.$t("message.linkSentToMailBox"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                    setTimeout(() => {
                        this.showModal = false;
                    }, 500);
                } catch (e) {
                    this.$toasted.error(this.$t("message.errorOccurred"), {
                        duration: 3000,
                        position: "bottom-center",
                    });
                }
            } else return;
        },
    },
    watch() {
        this.email = this.user.email;
    },
};
</script>
<style>
.apps-wrapper {
    height: 100%;
    overflow: hidden;
}
.email-modal {
    .custom-modal-header {
        text-align: center;
    }

    .ant-modal-content {
        border-radius: 20px !important;
    }

    .custom-modal-body {
        background: transparent !important;
        text-align: center;

        .mr-auto {
            width: 100%;
            text-align: center;
        }
    }
}

.apps-main {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    background: #fff;
    .apps-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70%;
        z-index: 1;
        background: #e6e6e6 !important;
    }

    .left {
        height: 100%;
        width: 40%;
        position: relative;

        .text-area {
            font-family: "Poppins", sans-serif;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            position: absolute;
            top: 75%;
            left: 75%;
            transform: translate(-50%, -50%);
            z-index: 9;
            justify-content: start;
            color: #333333;

            .title {
                font-size: 45px;
                font-weight: 700;
                margin-bottom: 35px;
                width: max-content;
            }
            .description {
                text-align: center;
                font-size: 20px;
                font-weight: 700;
            }
            .buttons {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: start;
                height: 30%;

                .app-store {
                    img {
                        width: 150px;
                        height: 50px;
                        transition: 300ms all;

                        &:hover {
                            transform: scale(1.1);
                        }
                    }
                }

                .google-play {
                    img {
                        width: 130px;
                        height: 44px;
                        transition: 300ms all;

                        &:hover {
                            transform: scale(1.1);
                        }
                    }
                }
            }

            .email-button {
                .send-mail {
                    font-size: 16px;
                    background: #1a1a1a;
                    color: #fff;
                    width: 130px;
                    height: 40px;
                    border-radius: 10px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    transition: 300ms all;
                    font-weight: 500;

                    &:hover {
                        transform: scale(1.1);
                    }
                }
            }
        }
    }

    .right {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .gallery {
            display: flex;
            align-items: center;
            width: 90%;
            height: 100%;
            flex-direction: column;
            margin-top: 7%;
            .images {
                margin-top: 10px;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                margin-left: 85px;
                z-index: 2;
                .little {
                    width: 40% !important;
                }
                .image {
                    width: 24%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
